<h2 mat-dialog-title class="!p-4">Upload Contract</h2>
<mat-dialog-content>
	<app-upload-contract-smart [dealId]="data.dealId"></app-upload-contract-smart>
</mat-dialog-content>